import { track } from '../miniEvents';

import { TRACKING } from './constants';

export const trackSmartMetric = (smartMetricName: string) =>
  track(TRACKING.MESSAGES.SMART_METRIC, TRACKING.SCHEMAS.SMART_METRIC_SCHEMA, {
    name: smartMetricName,
  });
